import DynamicContentList from '../cms-components/blackrock/advisor-center/dynamic-list/DynamicContentList';

export const DynamicContentListComponent = DynamicContentList;
